// extracted by mini-css-extract-plugin
export var mediaTextAdvancedTable = "component-module--mediaTextAdvancedTable--698d4";
export var tableSubheadline = "component-module--tableSubheadline--ac25a";